const HOURS_OF_CACHE = 2

export default {
  methods: {
    async getCache (name: string): Promise<any | undefined> {
      const key = name + '-cache'
      const cache = localStorage.getItem(key)
      if (cache) {
        const json = await JSON.parse(cache)
        if (new Date().getTime() < json.ttl) {
          return json.data
        }
      }
      return undefined
    },

    setCache (name: string, data:any) {
      const key = name + '-cache'
      const date = new Date()
      date.setTime(date.getTime() + (HOURS_OF_CACHE * 3600000))
      const cache = {
        ttl: date.getTime(),
        data
      }
      localStorage.setItem(key, JSON.stringify(cache))
    }
  }
}
